export const JP_DATE_FORMAT = 'yyyy年MM月dd日HH時mm'